"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerTypes = exports.actionTypes = void 0;
var json_rpc_dispatcher_1 = require("@dealroadshow/json-rpc-dispatcher");
exports.actionTypes = {
    subscribe: 'subscribe',
    unsubscribe: 'unsubscribe',
};
exports.headerTypes = {
    requestUrl: 'socket.requestUrl',
    action: 'socket.action',
    routingKey: 'socket.routingKey',
};
/**
 * Helper that allow easy manipulations with Json Rpc 2.0 Object and allow support of Finsight Socket RPC Protocol
 */
var ProtocolHelper = /** @class */ (function () {
    function ProtocolHelper() {
    }
    /**
     * Get routing key from RpcObject
     */
    ProtocolHelper.getRoutingKey = function (request) {
        var headers = ProtocolHelper.getHeaders(request);
        return headers === null || headers === void 0 ? void 0 : headers[exports.headerTypes.routingKey];
    };
    /**
     * Check if Json Rpc Object is Finsight Socket Service Subscribe request
     */
    ProtocolHelper.isSubscribeRequest = function (request) {
        var headers = ProtocolHelper.getHeaders(request);
        return headers[exports.headerTypes.action] === exports.actionTypes.subscribe;
    };
    /**
     * Convert Json Rpc Object to Finsight Socket Service Subscribe request
     */
    ProtocolHelper.toSubscribeRequest = function (request) {
        return ProtocolHelper.addHeader(new json_rpc_dispatcher_1.RpcRequest(request), exports.headerTypes.action, exports.actionTypes.subscribe);
    };
    /**
     * Check if Json Rpc Object is Finsight Socket Service Unsubscribe request
     */
    ProtocolHelper.isUnsubscribeRequest = function (request) {
        var headers = ProtocolHelper.getHeaders(request);
        return headers[exports.headerTypes.action] === exports.actionTypes.unsubscribe;
    };
    /**
     * Convert Json Rpc Object to Finsight Socket Service Subscribe request
     */
    ProtocolHelper.toUnsubscribeRequest = function (request) {
        return ProtocolHelper.addHeader(new json_rpc_dispatcher_1.RpcRequest(request), exports.headerTypes.action, exports.actionTypes.unsubscribe);
    };
    /**
     * Bind request url to Json Rpc 2.0 Object
     */
    ProtocolHelper.bindRequestUrl = function (requestUrl, rpcObject) {
        return ProtocolHelper.addHeader(rpcObject, exports.headerTypes.requestUrl, requestUrl);
    };
    /**
     * Get headers from rpc object. Will check headers in objet root & inside of params, error, result attributes to
     * merge into resulting obj
     */
    ProtocolHelper.getHeaders = function (rpcObject) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var headers = {};
        if ('params' in rpcObject &&
            ((_a = rpcObject === null || rpcObject === void 0 ? void 0 : rpcObject.params) === null || _a === void 0 ? void 0 : _a.headers) &&
            (typeof rpcObject.params.headers === 'object')) {
            Object.assign(headers, rpcObject.params.headers);
        }
        if ('result' in rpcObject &&
            ((_b = rpcObject === null || rpcObject === void 0 ? void 0 : rpcObject.result) === null || _b === void 0 ? void 0 : _b.headers) &&
            (typeof rpcObject.result.headers === 'object')) {
            Object.assign(headers, rpcObject.result.headers);
        }
        if ('error' in rpcObject &&
            ((_d = (_c = rpcObject === null || rpcObject === void 0 ? void 0 : rpcObject.error) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.headers) &&
            (typeof ((_f = (_e = rpcObject.error) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.headers) === 'object')) {
            Object.assign(headers, (_h = (_g = rpcObject.error) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.headers);
        }
        return headers;
    };
    /**
     * Add header to the rpc object
     */
    ProtocolHelper.addHeader = function (rpcObject, headerName, headerValue) {
        var _a, _b, _c;
        var _d, _e, _f, _g, _h;
        var result = rpcObject;
        if ('params' in rpcObject) {
            result = __assign(__assign({}, rpcObject), { params: __assign(__assign({}, rpcObject.params), { headers: __assign(__assign({}, (_d = rpcObject.params) === null || _d === void 0 ? void 0 : _d.headers), (_a = {}, _a[headerName] = headerValue, _a)) }) });
        }
        if ('result' in rpcObject) {
            result = __assign(__assign({}, rpcObject), { result: __assign(__assign({}, rpcObject.result), { headers: __assign(__assign({}, (_e = rpcObject.result) === null || _e === void 0 ? void 0 : _e.headers), (_b = {}, _b[headerName] = headerValue, _b)) }) });
        }
        if ('error' in rpcObject) {
            result = __assign(__assign({}, rpcObject), { error: __assign(__assign({}, rpcObject.error), { data: __assign(__assign({}, (_f = rpcObject.error) === null || _f === void 0 ? void 0 : _f.data), { headers: __assign(__assign({}, (_h = (_g = rpcObject.error) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.headers), (_c = {}, _c[headerName] = headerValue, _c)) }) }) });
        }
        return new rpcObject.constructor(result);
    };
    return ProtocolHelper;
}());
exports.default = ProtocolHelper;
//# sourceMappingURL=ProtocolHelper.js.map